import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { updateQueryParams, resetFiltersparams, selectQueryParams } from "../ui/customerListingReducer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Popover } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { toast } from 'react-toastify';

const Filters = (props) => {
  const queryParams = useSelector(selectQueryParams);
  const dispatch = useDispatch();
  const [showOverlay, setShowOverlay] = useState(false);

  const onApplyFiltersClick = () => {
    if(props.filtersModel && Object.keys(props.filtersModel).length > 0){
      dispatch(updateQueryParams({
        queryParams: {
          ...queryParams,
          page: 1,
          per_page: 25,
          filters: JSON.parse(JSON.stringify(props.filtersModel)),
        }
      }));
      setShowOverlay(false);
    } else {
      setShowOverlay(false);
    }
  }

  const onClearFiltersClick = () => {
    if(props.filtersModel && Object.keys(props.filtersModel).length > 0){
      props.setFiltersModel({});
      dispatch(resetFiltersparams());
      setShowOverlay(false);
    } else {
      setShowOverlay(false);
    }
  }

  return <>
    <OverlayTrigger
      trigger="click"
      placement="bottom"
      show={showOverlay}
      onToggle={() => setShowOverlay(!showOverlay)}
      overlay={
        <Popover style={{ width: "70%", zIndex: "98" }}>
          <Popover.Header as="h3">
            Filter
          </Popover.Header>
          <Popover.Body>
            {props.children}
            <Form.Group>
              <button
                type="button"
                onClick={onApplyFiltersClick}
                style={{float: 'left', marginBottom: '20px'}}
                className='btn btn-sm btn-voltup-theme mt-3'
              >
                Apply
              </button>
              <button
                type="button"
                onClick={onClearFiltersClick}
                style={{float: 'left', marginBottom: '20px'}}
                className='btn btn-sm btn-voltup-theme mt-3'
              >
                Clear
              </button>
            </Form.Group>
          </Popover.Body>
        </Popover>
      }
    >
      <button className="s-btn" style={{ width: "150px" }}>
        <FontAwesomeIcon className="icon me-2" icon={faFilter} />
        <span>Filter</span>
      </button>
    </ OverlayTrigger>
  </>
};

export default Filters;
